module.exports = __webpack_public_path__ + "img/LU Quest Long Logo_No Tag Line500x46.c601e76c.png";